import * as commonActionTypes from '../common/action-types'
import * as actionTypes from './action-types'
import * as mutationTypes from './mutation-types'
import { customerConfigApi } from '../../../api/api.customerConfig'

export default {
    [actionTypes.GET_CONFIGURATION_ASYNC]({ dispatch, commit }) {
        dispatch(commonActionTypes.OPEN_PENDING_CALL)
        return customerConfigApi
            .getConfigurations()
            .then(r => commit(mutationTypes.CONFIGURATION_UPDATED, r.data))
            .finally(() => dispatch(commonActionTypes.CLOSE_PENDING_CALL))
    },
    [actionTypes.SET_SELECTED_APPLICATION]({ commit }, selectedCustomerApplicationId) {
        commit(mutationTypes.APPLICATION_SELECTED, selectedCustomerApplicationId)
    }
}